var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full py-8"},[(_vm.stripeId)?_c('ConfirmPlan',{attrs:{"stripe-id":_vm.stripeId}}):_c('div',[_vm._v(" Plan missing from URL ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }